import React from "react";
import { Calendar } from 'primereact/calendar';
import { addLocale } from 'primereact/api';
import { giorniBreviIt, giorniIt, mesiBreviIt, mesiIt } from "../utility/common";


function NsDatePicker({
                          nome,
                          dataSelezionata,
                          setSelectedDate,
                          showTimeSelect = undefined,
                          invalid = undefined,
                          maxDate = null,
                          minDate = null,
                          placeholder = null,
                          addictionalFiledClasses = '',
                          formikRef,
                      }) {

    addLocale('it', {
        firstDayOfWeek: 0,
        showMonthAfterYear: true,
        dayNames: giorniIt,
        dayNamesShort: giorniBreviIt,
        dayNamesMin: ['D', 'L', 'M', 'M', 'G', 'V', 'S'],
        monthNames: mesiIt,
        monthNamesShort: mesiBreviIt,
        today: 'Oggi',
        clear: 'Elimina'
    });

    return <Calendar
        id={nome}
        name={nome}
        locale={'it'}
        className={"w-100 " + addictionalFiledClasses}
        value={dataSelezionata && new Date(dataSelezionata)}
        onChange={(date, e) => {
            if (formikRef) {
                formikRef.current.setFieldValue(nome, date.value)
            }
            setSelectedDate(date.value)
        }}
        maxDate={maxDate}
        minDate={minDate}
        dateFormat={"dd/mm/yy"}
        placeholder={placeholder} //placeholderText
        showTime={showTimeSelect}
        hourFormat="24"
        invalid={invalid}
        pt={{ panel: () => ({className: 'ns-z-index' } ) }}
    />
}

export default NsDatePicker;